package com.castly.admin.dto

import kotlinx.serialization.Serializable

/**
 * Paginated list response for content endpoints
 * Used by GET /api/v1/content endpoint
 *
 * Frontend copy (Kotlin/JS compatible)
 */
@Serializable
data class ContentListResponse(
    val items: List<ContentResponse>,
    val total: Int,
    val page: Int,
    val pageSize: Int
)
